import * as React from 'react';
import SearchIcon from '@mui/icons-material/Search';

// Utils
import { useTranslation } from 'react-i18next'
import { ButtonText, CustomIconButton, InputContainer, InputText } from './styles';
import { useMediaQuery, useTheme } from '@mui/material';

export const SearchBarUsers = ({
    setFilteredRequest,
    rows,
    searchText,
    handleChangeFilter
}) => {

    const { t } = useTranslation();
    const [search, setSearch] = React.useState('')
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.only("sm"));

    function handleSearch(e) {
        setSearch(e)
        searchText.current = e
    }

    React.useEffect(() => {
        setFilteredRequest(rows);
        handleSearch(search);
    }, [rows])

    return (
        <InputContainer
            component="form"
            elevation={0}
        >
            <InputText
                type='text'
                name='search'
                value={search}
                onChange={e => handleSearch(e.target.value)}
                autoComplete='off'

                sx={{ display: 'flex', flex: 1, ml: 1, }}
                placeholder={isMobile ? t('common.search') : t('system.users.table.searchBar')}
                inputProps={{ 'aria-label': 'search google maps' }}
            />
            <CustomIconButton type="button" aria-label="search" onClick={handleChangeFilter}>
                <ButtonText pr={1}>
                  {isMobile ? '' : t("common.search")}
                </ButtonText>
                <SearchIcon />
            </CustomIconButton>
        </InputContainer>
    );
}